import React from "react";
import './Modal.css'

function Modal({
    open = false,
    onClose,
    children
}) {

    React.useEffect(() => {
        document.body.classList[open ? 'add' : 'remove']('bodyNoScrollable');
    }, [open])

    return (
        <div className={`modal ${open ? "open" : ""}`}>
            <div className='content'>
                <span className='close' onClick={() => onClose(false)}>{"\u00D7"}</span>
                <div>{children}</div>
            </div>
            {children}
        </div>
    )
}

export default React.memo(Modal);
